import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "8:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-1-mode.png`,
        },
      },
    },
  },
  "8:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-2-modes.png`,
        },
      },
    },
  },
  "8:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-3-modes.png`,
        },
      },
    },
  },
  "8:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-4-modes.png`,
        },
      },
    },
  },
  "8:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-5-modes.png`,
        },
      },
    },
  },
  "8:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-6-modes.png`,
        },
      },
    },
  },
  "8:7": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-7-modes.png`,
        },
      },
    },
  },
  "8:8": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-8-modes.png`,
        },
      },
    },
  },
  "8:9": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-9-modes.png`,
        },
      },
    },
  },
  "8:10": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-10-modes.png`,
        },
      },
    },
  },
  "8:11": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-11-modes.png`,
        },
      },
    },
  },
  "8:12": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-12-modes.png`,
        },
      },
    },
  },
  "8:13": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-13-modes.png`,
        },
      },
    },
  },
  "8:14": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-14-modes.png`,
        },
      },
    },
  },
};

export default components;
